module.exports = __webpack_public_path__ + "static/img/9.2fbc3b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/zh/9.png
// module id = 1Mas
// module chunks = 0